<template>
  <section>
    <output v-show="isDebug">{{ JSON.stringify(cerebralArteries) }} </output>
    <svg
      viewBox="0 0 1013 570"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="1013" height="570" fill="url(#pattern0)" />
      <g
        v-if="isantCircle"
        @click="selected('AnteriorCerebralArtery')"
        :class="
          cerebralArteries.includes('AnteriorCerebralArtery') ? 'selected' : ''
        "
      >
        <rect x="359" y="29" width="160" height="19" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="41.6364">Anterior Cerebral Artery (ACA)</tspan>
        </text>
        <line
          x1="221.011"
          y1="36.5"
          x2="359.011"
          y2="37.5073"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="518.121"
          y1="36.3436"
          x2="685.121"
          y2="149.344"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="685"
          y1="148"
          x2="685"
          y2="272"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isantCircle"
        @click="selected('MeanCerebralArtery')"
        :class="
          cerebralArteries.includes('MeanCerebralArtery') ? 'selected' : ''
        "
      >
        <rect x="359" y="93" width="148" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="106.636">Mean Cerebral Artery (MCA)</tspan>
        </text>
        <line
          x1="317.913"
          y1="83.2204"
          x2="356.913"
          y2="103.22"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isantCircle"
        @click="selected('InternalCarotidArtery')"
        :class="
          cerebralArteries.includes('InternalCarotidArtery') ? 'selected' : ''
        "
      >
        <rect x="359" y="153" width="151" height="19" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="165.636">Internal Carotid Artery (ICA)</tspan>
        </text>
        <line
          x1="267.004"
          y1="107.27"
          x2="360.004"
          y2="161.27"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isantCircle"
        @click="selected('PericallosalArtery')"
        :class="
          cerebralArteries.includes('PericallosalArtery') ? 'selected' : ''
        "
      >
        <rect x="658" y="29" width="116" height="20" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="660" y="41.6364">Pericallosal Artery (PA)</tspan>
        </text>
        <line
          x1="714.5"
          y1="185"
          x2="714.5"
          y2="49"
          stroke="black"
          stroke-width="3"
        />
      </g>
      <g
        v-if="isantCircle"
        @click="selected('AnteriorCommunicatingCerebralArtery')"
        :class="
          cerebralArteries.includes('AnteriorCommunicatingCerebralArtery')
            ? 'selected'
            : ''
        "
      >
        <rect x="359" y="203" width="240" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="216.636">
            Anterior Communicating Cerebral Artery (ACoA)
          </tspan>
        </text>
        <line
          x1="204.053"
          y1="118.3"
          x2="359.053"
          y2="214.3"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="203.5"
          y1="54"
          x2="203.5"
          y2="120"
          stroke="black"
          stroke-width="3"
        />
      </g>
      <g
        v-if="isantCircle"
        @click="selected('PosteriorCommunicatingCerebralArtery')"
        :class="
          cerebralArteries.includes('PosteriorCommunicatingCerebralArtery')
            ? 'selected'
            : ''
        "
      >
        <rect x="359" y="255" width="244" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="268.636">
            Posterior Communicating Cerebral Artery (PCoA)
          </tspan>
        </text>
        <line
          x1="258.117"
          y1="196.341"
          x2="359.117"
          y2="264.341"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('PosteriorCerebralArtery')"
        :class="
          cerebralArteries.includes('PosteriorCerebralArtery') ? 'selected' : ''
        "
      >
        <rect x="358" y="307" width="164" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="320.636">Posterior Cerebral Artery (PCA)</tspan>
        </text>
        <line
          x1="317.651"
          y1="253.872"
          x2="358.651"
          y2="313.872"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="522"
          y1="315.5"
          x2="785"
          y2="315.5"
          stroke="black"
          stroke-width="3"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('SuperiorCerebellarArtery')"
        :class="
          cerebralArteries.includes('SuperiorCerebellarArtery')
            ? 'selected'
            : ''
        "
      >
        <rect x="358" y="334" width="169" height="20" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="366" y="346.636">Superior Cerebellar Artery (SCA)</tspan>
        </text>
        <line
          x1="288.424"
          y1="269.596"
          x2="358.424"
          y2="340.596"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="527"
          y1="340.5"
          x2="748"
          y2="340.5"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="791.551"
          y1="323.395"
          x2="748.552"
          y2="340.395"
          stroke="black"
          stroke-width="3"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('BasilarArtery')"
        :class="cerebralArteries.includes('BasilarArtery') ? 'selected' : ''"
      >
        <rect x="358" y="362" width="103" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="363" y="375.636">Basilar Artery (BA)</tspan>
        </text>
        <line
          x1="208.918"
          y1="292.223"
          x2="357.918"
          y2="369.223"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="461.005"
          y1="368.5"
          x2="765.005"
          y2="369.5"
          stroke="black"
          stroke-width="3"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('AnteriorInferiorCerebellarArtery')"
        :class="
          cerebralArteries.includes('AnteriorInferiorCerebellarArtery')
            ? 'selected'
            : ''
        "
      >
        <rect x="358" y="416" width="210" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="363" y="429.636">
            Anterior Inferior Cerebellar Artery (AICA)
          </tspan>
        </text>
        <line
          x1="306.245"
          y1="379.435"
          x2="355.245"
          y2="418.435"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="354.414"
          y1="417.586"
          x2="358.414"
          y2="421.586"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="753"
          y1="422.5"
          x2="568"
          y2="422.5"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="807.345"
          y1="372.48"
          x2="752.345"
          y2="422.48"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('VertebralArtery')"
        :class="cerebralArteries.includes('VertebralArtery') ? 'selected' : ''"
      >
        <rect x="358" y="478" width="116" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="363" y="491.636">Vertebral Artery (VA)</tspan>
        </text>
        <line
          x1="259.471"
          y1="463.056"
          x2="358.471"
          y2="487.056"
          stroke="black"
          stroke-width="4"
        />
        <line
          x1="474"
          y1="485.5"
          x2="759"
          y2="485.5"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="796.66"
          y1="428.116"
          x2="757.66"
          y2="486.116"
          stroke="black"
          stroke-width="4"
        />
      </g>
      <g
        v-if="isPostCircle"
        @click="selected('PosteriorInferiorCerebellarArtery')"
        :class="
          cerebralArteries.includes('PosteriorInferiorCerebellarArtery')
            ? 'selected'
            : ''
        "
      >
        <rect x="358" y="543" width="213" height="21" fill="#D9D9D9" />
        <text
          fill="black"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Sans-Serif"
          font-size="10"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="363" y="556.636">
            Posterior Inferior Cerebellar Artery (PICA)
          </tspan>
        </text>
        <line
          x1="295.212"
          y1="543.515"
          x2="358.212"
          y2="552.515"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="571"
          y1="551.5"
          x2="816"
          y2="551.5"
          stroke="black"
          stroke-width="3"
        />
        <line
          x1="816.5"
          y1="412.011"
          x2="815.5"
          y2="553.011"
          stroke="black"
          stroke-width="3"
        />
      </g>

      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_3_54_1" transform="scale(0.000987167 0.00175439)" />
        </pattern>
        <image id="image0_3_54_1" width="1013" height="570" :href="cerebralArteriesImageUrl"/>
      </defs>
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
  ValuesSetValue,
} from '@dandelion/core';
import { computed, onBeforeMount, ref, Ref, watch } from 'vue';
import { isEqual } from 'lodash';

import cerebralArteriesImageUrl from '../../public/images/cerebralArteries.png';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const cerebralArteries = ref<Array<string>>([]);
const isDebug = coreConfiguration.debug;

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;
  // Imposta il valore selezionato come unico elemento dell'array
  cerebralArteries.value = [selected];
  // Aggiorna il modello
  Helpers.setObjByPath(props.fullName, model, cerebralArteries.value);
}

const model = currentCaseService.getModel();
const aneuLoc = computed(
  () => model.core?.clinicalConditionsOnAdmission?.aneuLoc
);

const isPostCircle = computed(() => {
  return aneuLoc.value?.value === 'aneuLocCod.postCircle';
});

const isantCircle = computed(() => {
  return aneuLoc.value?.value === 'aneuLocCod.antCircle';
});

watch(aneuLoc, (newLoc: ValuesSetValue, oldLoc: ValuesSetValue) => {
  if (newLoc?.getValue() !== oldLoc?.getValue()) {
    // reset della selezione locale
    cerebralArteries.value = [];
    // reset nel modello
    Helpers.setObjByPath(props.fullName, model, []);
  }
});

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;
  const cerebralArteriesFromModel = Helpers.getObjByPath(props.fullName, model);

  if (!cerebralArteries.value) {
    return;
  }
  cerebralArteries.value = cerebralArteriesFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }
  const model = await currentCaseService.getModel();
  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}
</script>

<style scoped>
g:hover rect {
  stroke: #4030ff !important;
  cursor: pointer;
}

g:hover text {
  cursor: pointer;
}

.selected rect {
  fill: red;
}

.selected line {
  stroke: red;
}
</style>
